import { Button } from '@/cn/ui/button'
import CrayDemoNFTBuyer from '@/constants/cray_demo_nft_buyer.json'
import CrayPayButton from '@craynetwork/react-pay'
import { DESTINATION_ACTION_ADDRESS } from '@/constants'
const API_KEY = import.meta.env.VITE_DEMO_GATEWAY_API_KEY
const outputToken = '0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d'

const DemoApp = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-6">
      <div className="flex items-center gap-4">
        <div className="bg-green-500 rounded-full w-2 h-2 animate-pulse "></div>
        <span className="text-xl font-bold text-green-500">Minting is live!</span>
      </div>
      <h1 className="text-6xl  text-black font-bold mb-8 leading-tide">Demo DApp</h1>
      <img src="/cray-nft.webp" className="w-[300px] h-[300px] rounded-md shadow-lg" />
      <CrayPayButton
        testnet={true}
        apiKey={API_KEY}
        onPaymentStarted={(e) => console.log('paymentStarted', e)}
        onPaymentCompleted={(e) => console.log('paymentCompeted', e)}
        onPaymentFailed={(e) => console.log('paymentFailed', e)}
        payload={{
          destinationAddress: DESTINATION_ACTION_ADDRESS,
          destinationToken: outputToken,
          destinationChain: 84532,
          amount: '.1',
          action: {
            payload: {
              abi: CrayDemoNFTBuyer,
              functionName: 'mint',
              args: ['$$senderAddress'],
            },
            gasLimit: 200000,
          },
        }}
      >
        <Button>Mint Now 0.00065 ETH</Button>
      </CrayPayButton>
    </div>
  )
}
export default DemoApp
